import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    IconType,
} from 'app/enums/common.enums'
import {
    ContractCurrency,
} from 'app/enums/label.enums'
import TextIcon from 'app/common/DomainObject/ComponentMapper/TextIcon/TextIcon'
import {
    CQuotesTable,
} from 'app/Apps/AccountManagement/CQuotes/CQuotes.types'

const getColumns = ({
    l,
}: { l: (s: string) => string }): RichTableColumns<keyof CQuotesTable>[] => {
    return [
        {
            id: 'quoteNumber',
            headerProps: {
                children: l('AccountQuotes.quoteNumber'),
            },
            mapCellProps: ({
                quoteNumber,
                pricingInProgressWithLane,
                pricingInProgressWithLaneFee,
            }) => {
                return {
                    value: quoteNumber,
                    type: (pricingInProgressWithLane || pricingInProgressWithLaneFee)
                        ? IconType.Warning : undefined,
                }
            },
            Cell: TextIcon,
        },
        {
            id: 'quotedForCompanyLocationName',
            headerProps: {
                children: l('AccountQuotes.quotedForCompany'),
            },
            mapCellProps: 'quotedForCompanyLocationName',
        },
        {
            id: 'originAirportIataCode',
            headerProps: {
                children: l('AccountLane.originAirport'),
            },
            mapCellProps: 'originAirportIataCode',
        },
        {
            id: 'destinationAirportIataCode',
            headerProps: {
                children: l('AccountLane.destinationAirport'),
            },
            mapCellProps: 'destinationAirportIataCode',
        },
        {
            id: 'currency',
            headerProps: {
                children: l('AccountQuotes.currency'),
            },
            mapCellProps: 'currency',
            componentName: 'EnumValue',
            allowedValuesEnum: ContractCurrency,
        },
        {
            id: 'createdBy',
            headerProps: {
                children: l('AccountQuotes.createdBy'),
            },
            mapCellProps: 'createdBy',
        },
    ]
}

export default getColumns
